import { render } from "./FooterComponent.vue?vue&type=template&id=1f74fa09&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=1f74fa09&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kerok\\OneDrive\\デスクトップ\\仕事\\資料\\iConnect模擬案件\\develop\\EUHP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f74fa09"]])

export default __exports__